<template>
  <div class="container">
    <div class="top">
      <img src="@/assets/shop.png" alt="" class="topImg" />
      <div class="dot"></div>
      <img src="@/assets/topVisa.png" alt="" class="topImgVisa" />
      <div class="dot"></div>
      <img src="@/assets/topApg.png" alt="" class="topImgApg" />
    </div>
    <div class="centerPlace">
      <div class="center">
        <div style="height: 34px">
          <div class="centerTop">
            <div class="Item">
              <div class="itemTop"></div>
              <div class="itemBottom"></div>
            </div>
            <div class="Item">
              <div class="itemTop"></div>
              <div class="itemBottom"></div>
            </div>
            <div class="Item">
              <div class="itemTop"></div>
              <div class="itemBottom"></div>
            </div>
            <div class="Item">
              <div class="itemTop"></div>
              <div class="itemBottom"></div>
            </div>
          </div>
        </div>
        <img src="@/assets/popup.png" alt="" class="popupImg" />
        <div class="centerDay">
          <div class="number">5</div>
          <div class="text">天</div>
          <img src="@/assets/gateways.png" alt="" class="img" />
        </div>
        <img src="@/assets/money.png" alt="" class="money" />
        <div class="bankList">
          <div class="title">支付方式支持：</div>
          <div class="imgList">
            <div class="imgItem visa">
              <img src="@/assets/bank/visa.png" alt="" />
            </div>
            <div
              class="imgItem img2">
              <img src="@/assets/bank/cic.png" alt="" />
            </div>
            <div class="imgItem img3">
              <img src="@/assets/bank/jcb.png" alt="" />
            </div>
            <div
              class="imgItem img4">
              <img src="@/assets/bank/doub.png" alt="" />
            </div>
          </div>
          <div class="imgList">
            <div class="imgItem img5">
              <img src="@/assets/bank/Slice 17@2x.png" alt="" />
            </div>
            <div
              class="imgItem img6">
              <img src="@/assets/bank/Slice 18@2x.png" alt="" />
            </div>
            <div class="imgItem img7">
              <img src="@/assets/bank/Slice 19@2x.png" alt="" />
            </div>
            <div class="imgItem img8">
              <img src="@/assets/bank/Slice 20@2x.png" alt="" />
            </div>
          </div>
          <div class="imgList">
            <div class="imgItem img9">
              <img src="@/assets/bank/Slice 21@2x.png" alt="" />
            </div>
            <div
              class="imgItem img10">
              <img src="@/assets/bank/Slice 22@2x.png" alt="" />
            </div>
            <div class="imgItem img11">
              <img src="@/assets/bank/Slice 23@2x.png" alt="" />
            </div>
            <div class="imgItem img12">
              <img src="@/assets/bank/Slice 24@2x.png" alt="" />
            </div>
          </div>
          <div class="imgList">
            <div class="imgItem img13">
              <img src="@/assets/bank/Slice 25@2x.png" alt="" />
            </div>
            <div
              class="imgItem img14">
              <img src="@/assets/bank/Slice 26@2x.png" alt="" />
            </div>
            <div class="imgItem img15">
              <img src="@/assets/bank/Slice 27@2x.png" alt="" />
            </div>
            <div class="imgItem img16">
              <img src="@/assets/bank/Slice 28@2x.png" alt="" />
            </div>
          </div>
          <img src="@/assets/Frame.png" alt="" class="introduce" />
          <!-- <div class="introduce">活动介绍：</div>
          <div class="content">
            <p>
              店匠SHOPLAZZA客户在2022年12月31日18:00前通过APG开户并使用银盛外卡支付通道3个月累计交易额大于5,000美元后，即可获得店匠SHOP-LAZZA提供的
            </p> -->
          <!-- <div class="redText">
            <img src="@/assets/red.png" alt="" class="red" />
          </div> -->
          <!-- <div class="notice">注：活动细则以店匠SHOPLAZZA公告为准</div>
          </div> -->
        </div>
        <div class="bottom">
          <!-- <img src="@/assets/QRcode.png" alt="" class="qrcode" />
          <div class="bottomCenter">
            <div class="top">
              <img src="@/assets/arrow.png" alt="" class="img" />
              <span class="text">别看了</span>
            </div>
            <div class="more">快联系我们获取更多信息</div>
            <div class="email">service@airpaynet.com</div>
          </div>
          <div class="line"></div>
          <div class="discount">
            <span style="font-size: 8px;font-weight: bold;">立减</span>
            <span>70% </span>
          </div> -->
          <img src="@/assets/bottom.png" alt="" class="img" />
          <!-- <span @click="toHref" class="email">service@airpaynet.com</span> -->
          <a href="mailto:service@airpaynet.com" class="email">service@airpaynet.com</a>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyTabBar",
  methods:{
    toHref(){
      window.open("http://service@airpaynet.com")
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  .top {
    display: flex;
    align-items: center;
    .topImg {
      width: 88px;
      height: 24px;
    }
    @media screen and (min-width: 1125px) {
      .topImg {
        width: 263PX;
        height: 64.8PX;
      }
    }
    .dot {
      width: 3px;
      height: 3px;
      border-radius: 50%;
      background-color: white;
      margin-left: 11px;
      margin-right: 7px;
    }
    @media screen and (min-width: 1125px) {
      .dot {
        width: 10PX;
        height: 10PX;
        border-radius: 50%;
        background-color: white;
        margin-left: 33PX;
        margin-right: 21PX;
      }
    }

    .topImgVisa {
      width: 51px;
      height: 18px;
    }
    @media screen and (min-width: 1125px) {
      .topImgVisa {
        width: 154PX;
        height: 50PX;
      }
    }

    .topImgApg {
      width: 70px;
      height: 18px;
    }
    @media screen and (min-width: 1125px) {
      .topImgApg {
        width: 211PX;
        height: 54PX;
      }
    }
  }
  .centerPlace {
    min-height: 767px;
    _height: 767px;
  }
  .center {
    position: relative;
    // overflow: hidden;
    width: 100%;
    height: 723px;
    margin-top: 41px;
    background: #f0f5fc;
    border-radius: 7px 7px 7px 7px;
    opacity: 1;
    .centerTop {
      height: 34px;
      display: flex;
      position: absolute;
      top: -17px;
      .Item {
        width: 19px;
        height: 34px;
        margin-left: 37px;
        .itemTop {
          width: 19px;
          height: 17px;
          background: #f0f5fc;
          border-radius: 3px 3px 0px 0px;
        }
        .itemBottom {
          width: 19px;
          height: 17px;

          border-radius: 0px 0px 3px 3px;
          background: #13118f;
        }
      }
    }
    .popupImg {
      position: absolute;
      top: -32px;
      right: -24px;
      width: 117px;
      // height: 76px;
    }
    .centerDay {
      display: flex;
      align-items: center;
      margin-top: 15px;
      margin-left: 46px;
      .number {
        width: 88px;
        height: 120px;
        text-align: center;
        line-height: 120px;
        color: #fe0000;
        margin-right: 12px;
        font-family: Source Han Sans SC-Bold, Source Han Sans SC;
        font-size: 87px;
        font-weight: bold;
        background: #ffffff;
        border-radius: 7px 7px 7px 7px;
        opacity: 1;
      }
      .text {
        width: 88px;
        height: 120px;
        text-align: center;
        line-height: 120px;
        color: #fe0000;
        font-size: 73px;
        font-weight: bold;
        font-family: Source Han Sans SC-Bold, Source Han Sans SC;
        background: #ffffff;
        border-radius: 7px 7px 7px 7px;
      }
      .img {
        width: 29px;
        height: 86px;
        margin-left: 14px;
      }
    }
    .money {
      width: 224px;
      height: 55px;
      margin-left: 51px;
      margin-top: 13px;
    }
    .bankList {
      width: 281px;
      height: 379px;
      margin-left: 23px;
      margin-top: 28px;
      background: #ffffff;
      border-radius: 3px 3px 3px 3px;
      .title {
        font-size: 8px;
        font-weight: bold;
        color: #000000;
        padding-top: 18px;
        box-sizing: border-box;
        margin-left: 19px;
        margin-bottom: 11px;
      }
      .imgList {
        display: flex;
        align-items: center;
        margin-left: 21px;
        margin-bottom: 18px;
        .visa {
          padding: 9px 0 8px 0
        }
        .img2 {
          padding: 6px 8px 5px 8px; 
          margin-left: 21px
        }
        .img3 {
          padding: 6px 11px; 
          margin-left: 10px
        }
        .img4 {
          padding: 5px 8px 4px 8px; 
          margin-left: 7px
        }
        .img5 {
          padding: 13px auto 13px 3px;
        }
        .img6 {
          padding: 3px 14px 3px 11px; 
          margin-left: 21px
        }
        .img7 {
          padding: 7px 8px; 
          margin-left: 10px
        }
        .img8 {
          padding: 11px 8px; 
          margin-left: 7px
        }
        .img9 {
          padding: 13px auto 13px 3px;
        }
        .img10 {
          padding: 3px 14px 3px 11px; 
          margin-left: 21px
        }
        .img11 {
          padding: 7px 8px; 
          margin-left: 10px
        }
        .img12 {
          padding: 11px 8px; 
          margin-left: 7px;
        }
        .img13 {
          padding: 13px auto 13px 3px;
        }
        .img14 {
          padding: 3px 14px 3px 11px; 
          margin-left: 21px;
        }
        .img15 {
          padding: 7px 8px; margin-left: 10px;
        }
        .img16 {
          padding: 11px 8px; 
          margin-left: 7px;
        }
        .imgItem {
          display: flex;
          width: 51px;
          justify-content: center;
          align-items: center;
          // margin-left: 21px;
          height: 33px;
          box-sizing: border-box;
          img {
            width: 100%;
          }
        }
      }
      // .introduce {
      //   font-size: 8px;
      //   font-weight: bold;
      //   margin-top: 14px;
      //   margin-left: 21px;
      // }
      // .content {
      //   position: relative;
      //   width: 237px;
      //   // height: 69px;
      //   // white-space: nowrap;
      //   font-family: Source Han Sans SC-Medium, Source Han Sans SC;
      //   margin-left: 21px;
      //   margin-top: 11px;
      //   font-size: 7px;
      //   line-height: 16px;
      //   font-weight: 500;
      //   color: #333333;
      //   .redText {
      //     .red {
      //       position: absolute;
      //       right: 0;
      //       bottom: 0;
      //       width: 115px;
      //       height: 20px;
      //     }
      //   }
      //   .notice {
      //     margin-top: 10px;
      //     font-size: 7px;
      //     color: #999999;
      //   }
      // }
      .introduce {
        margin-top: 14px;
        margin-left: 21px;
        width: 237px;
        // height: 69px;
      }
    }
    .bottom {
      // display: flex;
      // align-items: center;
      // // justify-content: center;
      position: relative;
      width: 295px;
      height: 96px;
      margin-top: 27px;
      margin-left: 16px;
      // background: #ffc4ab;
      // border-radius: 12px 12px 12px 12px;
      // opacity: 1;
      // .qrcode {
      //   width: 96px;
      //   height: 96px;
      //   border-radius: 12px 0px 0px 12px;
      // }
      // .bottomCenter {
      //   margin-left: 18px;

      //   .top {
      //     .img {
      //       width: 30px;
      //       height: 14px;
      //     }
      //     .text {
      //       margin-left: 9px;
      //       font-size: 12px;
      //       font-family: Source Han Sans SC-Bold, Source Han Sans SC;
      //       font-weight: bold;
      //     }
      //   }
      //   .more {
      //     margin-top: 12px;
      //     font-size: 7px;
      //     font-family: Source Han Sans SC-Light, Source Han Sans SC;
      //     font-weight: 300;
      //   }
      //   .email {
      //     font-size: 7px;
      //     font-weight: 500;
      //     color: #d32525;
      //   }
      // }
      // .line {
      //   width: 0px;
      //   height: 40px;
      //   margin-left: 14px;
      //   margin-right: 10px;
      //   opacity: 1;
      //   border: 1px solid #ffffff;
      // }
      .email {
        cursor: pointer;
        position: absolute;
        left: 114px;
        bottom: 23px;
        font-size: 7px;
font-family: Source Han Sans SC-Medium, Source Han Sans SC;
font-weight: 500;
color: #D32525;
      }
      .img {
        width: 100%;
      }
    }
  }
  @media screen and (min-width: 1125px) {
    .centerPlace {
      width: 981PX;
    min-height: 2169PX;
    _height: 2169PX;
  }
    .center {
      position: relative;
      // overflow: hidden;
      max-width: 981PX;
      // height: 2301PX;
      height: 2169PX;
      margin-top: 123PX;
      background: #f0f5fc;
      border-radius: 20PX 20PX 20PX 20PX;
      opacity: 1;
      .centerTop {
        height: 102PX;
        display: flex;
        position: absolute;
        top: -51PX;
        .Item {
          width: 56PX;
          height: 102PX;
          margin-left: 120PX;
          &:first-child {
            margin-left: 110PX;
          }
          .itemTop {
            width: 56PX;
            height: 51PX;
            background: #f0f5fc;
            border-radius: 8PX 8PX 0px 0px;
          }
          .itemBottom {
            width: 56PX;
            height: 51PX;

            border-radius: 0px 0px 8PX 8PX;
            background: #13118f;
          }
        }
      }
      .popupImg {
        position: absolute;
        top: -95PX;
        right: -72PX;
        width: 350PX;
        // height: 76px;
      }
      .centerDay {
      display: flex;
      align-items: center;
      margin-top: 114.02PX;
      margin-left: 138PX;
      .number {
        width: 264PX;
        height: 360PX;
        text-align: center;
        line-height: 360PX;
        color: #fe0000;
        margin-right: 35PX;

        font-family: Source Han Sans SC-Bold, Source Han Sans SC;
        font-size: 260PX;
        font-weight: bold;
        background: #ffffff;
        border-radius: 20PX 20PX 20PX 20PX;
        opacity: 1;
      }
      .text {
        width: 264PX;
        height: 360PX;
        text-align: center;
        line-height: 360PX;
        color: #fe0000;
        font-size: 218PX;
        font-weight: bold;
        font-family: Source Han Sans SC-Bold, Source Han Sans SC;
        background: #ffffff;
        border-radius: 20PX 20PX 20PX 20PX;
      }
      .img {
        width: 88PX;
        height: 256PX;
        margin-left: 42PX;
      }
    }
    .money {
      width: 672PX;
      height: 166PX;
      margin-top: 38PX;
      margin-left: 154PX;
    }
    .bankList {
      width: 843PX;
      height: 1136PX;
      margin-left: 68PX;
      margin-top: 83PX;
      background: #ffffff;
      border-radius: 8PX 8PX 8PX 8PX;
      .title {
        font-size: 24PX;
        font-weight: bold;
        color: #000000;
        padding-top: 54PX;
        box-sizing: border-box;
        margin-left: 56PX;
        margin-bottom: 33PX;
      }
      .imgList {
        display: flex;
        align-items: center;
        margin-left: 63PX;
        margin-bottom: 53PX;
        .visa {
          padding: 26PX 0 25PX 0 !important
        }
        .img2 {
          padding: 18PX 23PX 16PX 23PX !important;
          margin-left: 63PX !important;
        }
        .img3 {
          padding: 18PX 34PX 17PX 34PX !important;
          margin-left: 30PX !important;
        }
        .img4 {
          padding: 14PX 24PX 13PX 24PX !important;
          margin-left: 22PX !important;
        }
        .img5 {
          padding: 39PX 38PX auto 10PX !important;
        }
        .img6 {
          padding: 10PX 41PX 10PX 34PX !important;
          margin-left: 63PX !important;
        }
        .img7 {
          padding: 20PX 24PX !important;
          margin-left: 30PX !important;
        }
        .img8 {
          padding: 34PX 24PX !important;
          margin-left: 22PX !important;
        }
        .img9 {
          padding: 19PX 5PX 19PX 4PX !important;
        }
        .img10 {
          padding: 15PX 36PX 15PX 38PX !important;
          margin-left: 63PX !important;
        }
        .img11 {
          padding: 33PX 22PX 32PX 22PX !important;
          margin-left: 30PX !important;
        }
        .img12 {
          padding: 31PX 20PX 31PX 24PX !important;
          margin-left: 22PX !important;
        }
        .img13 {
          padding: 30PX auto 29px auto !important;
        }
        .img14 {
          padding: 30PX 33PX 30PX 32PX !important;
          margin-left: 63PX !important;
        }
        .img15 {
          padding: 31PX 23PX 30PX 23PX !important;
          margin-left: 30PX !important;
        }
        .img16 {
          padding: 31PX 23PX 31PX 25PX !important;
          margin-left: 22PX !important;
        }
        .imgItem {
          display: flex;
          width: 154PX;
          justify-content: center;
          align-items: center;
          // margin-left: 21px;
          height: 100PX;
          box-sizing: border-box;
          img {
            width: 100%;
          }
        }
      }
      // .introduce {
      //   font-size: 8px;
      //   font-weight: bold;
      //   margin-top: 14px;
      //   margin-left: 21px;
      // }
      // .content {
      //   position: relative;
      //   width: 237px;
      //   // height: 69px;
      //   // white-space: nowrap;
      //   font-family: Source Han Sans SC-Medium, Source Han Sans SC;
      //   margin-left: 21px;
      //   margin-top: 11px;
      //   font-size: 7px;
      //   line-height: 16px;
      //   font-weight: 500;
      //   color: #333333;
      //   .redText {
      //     .red {
      //       position: absolute;
      //       right: 0;
      //       bottom: 0;
      //       width: 115px;
      //       height: 20px;
      //     }
      //   }
      //   .notice {
      //     margin-top: 10px;
      //     font-size: 7px;
      //     color: #999999;
      //   }
      // }
      .introduce {
        margin-top: 44PX;
        margin-left: 63PX;
        width: 710PX;
        // height: 69px;
      }
    }
    .bottom {
      // display: flex;
      // align-items: center;
      // // justify-content: center;
      width: 885PX;
      height: 288PX;
      margin-top: 82PX;
      margin-left: 48PX;
      // background: #ffc4ab;
      // border-radius: 12px 12px 12px 12px;
      // opacity: 1;
      // .qrcode {
      //   width: 96px;
      //   height: 96px;
      //   border-radius: 12px 0px 0px 12px;
      // }
      // .bottomCenter {
      //   margin-left: 18px;

      //   .top {
      //     .img {
      //       width: 30px;
      //       height: 14px;
      //     }
      //     .text {
      //       margin-left: 9px;
      //       font-size: 12px;
      //       font-family: Source Han Sans SC-Bold, Source Han Sans SC;
      //       font-weight: bold;
      //     }
      //   }
      //   .more {
      //     margin-top: 12px;
      //     font-size: 7px;
      //     font-family: Source Han Sans SC-Light, Source Han Sans SC;
      //     font-weight: 300;
      //   }
      //   .email {
      //     font-size: 7px;
      //     font-weight: 500;
      //     color: #d32525;
      //   }
      // }
      // .line {
      //   width: 0px;
      //   height: 40px;
      //   margin-left: 14px;
      //   margin-right: 10px;
      //   opacity: 1;
      //   border: 1px solid #ffffff;
      // }
      .email {
        cursor: pointer;
        position: absolute;
        left: 342PX;
        bottom: 68PX;
        font-size: 20PX;
font-family: Source Han Sans SC-Medium, Source Han Sans SC;
font-weight: 500;
color: #D32525;
      }
      .img {
        width: 100%;
      }
    }
    }
  }
}
</style>
